<div class="convert-container" *ngIf="!showLoaderPage">
  <div class="bot-order-head">
    <h4 class="mb-3">Stop Bot</h4>
    <button class="bot-clear">
      <button class="bot-clear" (click)="prevPage()">
        <img src="assets/images/botclear.svg" alt="close" title="close" />
      </button> </button>
  </div>
  <div class="option-box detail-box" [class.active]="selectedOption === 'keep'" (click)="selectOption('keep')">
    <div class="option-icon">💱</div>
    <div>
      <div class="option-title">Keep {{currentTradePair.firstCurrencySymbol}} and USDT</div>
      <div class="option-desc">
        Close the bot, cancel all open orders, and return the full amounts of
        both {{currentTradePair.firstCurrencySymbol}} and USDT currencies to your balance
      </div>
      <br />
      <p>Received amount :
      <p>{{currentTradePair.firstCurrencySymbol}} :
        <b class="red_txt">{{ truncateDecimals(pendingQuantity, 4) }}</b>
      <p>{{currentTradePair.secondCurrencySymbol}} :
        <b class="green_txt">{{ truncateDecimals(pendingOrderValue, 4) }}</b>
      </p>
    </div>
  </div>
  <div class="option-box detail-box" [class.active]="selectedOption === 'convert'" (click)="selectOption('convert')">
    <div class="option-icon">🔁</div>
    <div>
      <div class="option-title">Convert to USDT</div>
      <div class="option-desc">
        Sell the base currency to USDT by market price
      </div>
      <br />
      <!-- <div class="balance-text detail-box" style="text-align: left;"> -->
      <p>Esitmate P&L :
        <b *ngIf="estimatePnl >= 0" class="green_txt">{{ truncateDecimals(estimatePnl, 4) }}</b>
        <b *ngIf="estimatePnl < 0" class="red_txt">{{ truncateDecimals(estimatePnl, 4) }}</b>
      </p>
      <p>Received Amount :
        <b *ngIf="parseFloat(receiveAmount) >= 0" class="green_txt">{{
          truncateDecimals(receiveAmount,4)
          }}</b>
        <b *ngIf="parseFloat(receiveAmount) < 0" class="red_txt">{{
          truncateDecimals(receiveAmount,4)
          }}</b>
      </p>
      <!-- </div> -->
    </div>
  </div>


  <button class="continue" (click)="closeBot()" [disabled]="isSubmitting">Continue</button>

  <p class="footer-text">
    Actual profits may vary with market volatility and are calculated after the
    bot is closed
  </p>
</div>


<div class="create-bot-head" *ngIf="showLoaderPage">
  <div class="bot-order-head">
    <h4>Cancel Bot</h4>
  </div>
  <div class="create-bot">
    <img src="../../../../assets/images/stopImage.png" alt="start" title="start" width="100px" />
    <!-- <img
        src="../../../../assets/images/completed.png"
        alt="start"
        title="start"
        /> -->
    <h6>Stopping Bot</h6>
    <p>Loading......</p>
    <div class="progress">
      <div class="progress-bar" role="progressbar" [attr.aria-valuenow]="loaderPercentage" aria-valuemin="0"
        aria-valuemax="100" [style.width.%]="loaderPercentage">
        <span class="sr-only">{{ loaderPercentage }}% Complete</span>
      </div>
    </div>
  </div>
</div>